<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">会员管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">运营记录</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">余额记录管理</span></h2>
      <el-button type="primary" @click="showAdjustDialog">手动调整余额</el-button>
    </div>

    <el-form :inline="true" style="margin-bottom:16px">
      <el-form-item label="用户">
        <el-input v-model="filterUserId" placeholder="用户ID/手机号" style="width:160px" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filterType" placeholder="全部" clearable style="width:120px">
          <el-option label="充值" value="recharge" />
          <el-option label="消费" value="consume" />
          <el-option label="退款" value="refund" />
          <el-option label="调整" value="adjustment" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="fetchData">查询</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="records" stripe v-loading="loading">
      <el-table-column label="用户" min-width="120"><template #default="{row}">{{row.user?.name||row.user?.phone||'-'}}</template></el-table-column>
      <el-table-column label="手机号" width="130"><template #default="{row}">{{row.user?.phone||'-'}}</template></el-table-column>
      <el-table-column label="类型" width="100"><template #default="{row}"><el-tag :type="tagType(row.type)" size="small">{{typeLabel(row.type)}}</el-tag></template></el-table-column>
      <el-table-column label="变动金额" width="120"><template #default="{row}"><span :style="{color: row.amount>0?'#67c23a':'#f56c6c',fontWeight:'bold'}">{{row.amount>0?'+':''}}{{row.amount}}</span></template></el-table-column>
      <el-table-column label="变动后余额" width="120" prop="balance_after"/>
      <el-table-column label="备注" prop="remark" min-width="200" show-overflow-tooltip/>
      <el-table-column label="时间" width="160"><template #default="{row}">{{formatDateTime(row.created_at)}}</template></el-table-column>
    </el-table>

    <el-pagination
      v-if="pagination.total > 0"
      v-model:current-page="pagination.current_page"
      v-model:page-size="pagination.per_page"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20,50]"
      small
      background
      style="margin-top:16px;justify-content:flex-end"
      @current-change="fetchData"
      @size-change="fetchData"
    />

    <el-dialog v-model="adjustDialog" title="手动调整余额" width="450px">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="用户" prop="user_id">
          <el-select v-model="form.user_id" filterable remote :remote-method="searchUsers" placeholder="搜索用户手机号" style="width:100%">
            <el-option v-for="u in userOptions" :key="u.id" :label="u.name+'-'+u.phone" :value="u.id"/>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type">
            <el-option label="充值" value="recharge"/>
            <el-option label="手动调整" value="adjustment"/>
            <el-option label="退款" value="refund"/>
            <el-option label="消费扣减" value="consume"/>
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input-number v-model="form.amount" :precision="2" :min="0.01" :step="10"/>
          <div class="tip">正数为增加，负数为扣减，使用"消费扣减"类型</div>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="adjustDialog=false">取消</el-button>
        <el-button type="primary" @click="handleAdjust" :loading="saving">确认调整</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';import { ElMessage } from 'element-plus';import * as api from '../../api/userExtensions';
import { fetchAccounts as searchUsersApi } from '../../api/account';
const records=ref([]);const loading=ref(false);const filterUserId=ref('');const filterType=ref('');
const pagination = reactive({ current_page: 1, per_page: 20, total: 0, last_page: 1 });
const adjustDialog=ref(false);const saving=ref(false);const formRef=ref(null);
const userOptions=ref([]);
const form=ref({user_id:'',type:'recharge',amount:0,remark:'',related_order_no:''});
const rules={user_id:[{required:true,message:'请选择用户'}],type:[{required:true,message:'请选择类型'}],amount:[{required:true,message:'请输入金额'}]};
const typeLabel=(t)=>({recharge:'充值',adjustment:'手动调整',refund:'退款',consume:'消费扣减'}[t]||t);
const tagType=(t)=>({recharge:'success',consume:'danger',refund:'warning',adjustment:'info'}[t]||'info');
const fetchData=async()=>{loading.value=true;try{const params={page:pagination.current_page,per_page:pagination.per_page};if(filterUserId.value)params.user_id=filterUserId.value;if(filterType.value)params.type=filterType.value;const r=await api.getBalanceRecords(params);records.value=r.data||[];pagination.current_page=r.pagination?.current_page||1;pagination.total=r.pagination?.total||0}catch{}finally{loading.value=false}};
const searchUsers=async(q)=>{if(!q)return;try{const r=await searchUsersApi({search:q});userOptions.value=r.data||[]}catch{}};
const showAdjustDialog=()=>{form.value={user_id:'',type:'recharge',amount:0,remark:'',related_order_no:''};adjustDialog.value=true};
const handleAdjust=async()=>{const v=await formRef.value.validate().catch(()=>false);if(!v)return;saving.value=true;try{await api.adjustBalance(form.value);ElMessage.success('操作成功');adjustDialog.value=false;await fetchData()}catch(e){ElMessage.error(e.response?.data?.message||'操作失败')}finally{saving.value=false}};
const formatDateTime=(v)=>{if(!v)return'-';const d=new Date(v);if(isNaN(d.getTime()))return v;return d.toLocaleString('zh-CN',{year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit'})};
onMounted(fetchData);
</script>
<style scoped>
.tip{font-size:12px;color:#999;margin-top:4px}
</style>
